export default {
	setLocale(state, locale) {
		window.localStorage.setItem(process.env.VUE_APP_LOCALE_KEY, locale)
	},

	addToastMessage(state, payload) {
		state.messages = { ...state.messages, ...payload }
	},

	removeToastMessage(state, payload) {
		if (state.messages[payload]) {
			state.messages[payload].cb && state.messages[payload].cb()
			delete state.messages[payload]
			state.messages = { ...state.messages }
		}
	},

	CLEAR_TOAST_MESSAGE(state) {
		state.messages = {}
	},

	updateTenantId(state, tenantId) {
		state.tenantId = tenantId
	},

	setTenantId(state, tenantId) {
		state.tenantId = tenantId
	},

	setClientId(state, clientId) {
		state.clientId = clientId
	}
}
